import * as React from 'react';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import StringField from './StringField';

import {
    createResourceBrowserDialog,
    ResourceBrowser
} from '../../../pdc-widget-resource-manager/src/ts/react/ResourceBrowser';

export interface IUriFieldOptions {
    canBrowse?: boolean;
    browseTitle?: string;
    readOnly?: boolean;
    inline?: boolean;
    browseInstanceId?: string;
    placeholder?: string;
    delayChangeInterval?: number;

    onURLSet?(value: string): void;
    onBrowse?(callback: (value: string) => any): void;
}

export interface IUriFieldProperties extends IUriFieldOptions {
    value?: string;
    options?: IUriFieldOptions;
    glob?: IGlob;

    onChange?(value: string): void;
}

export default function UriField(props: IUriFieldProperties) {
    const [value, setValue] = React.useState(props.value);

    React.useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const handleOnChange = (value: string) => {
        if (typeof props.onChange === 'function') {
            if (value != null) {
                value = value.trim();

                if (value !== '') {
                    value = encodeURI(value.trim());
                } else {
                    value = null;
                }
            }

            setValue(value);
            props.onChange(value); //.replace(/ /g, '%20'));
        }
    };

    const { options } = props;
    const readOnly = props.readOnly || (options != null && options.readOnly);
    const canBrowse = props.canBrowse || (options != null && options.canBrowse);

    let content = (
        <StringField
            value={value}
            changeOnBlurOnly={props.delayChangeInterval == null}
            delayChangeInterval={props.delayChangeInterval}
            readOnly={readOnly}
            placeholder={props.placeholder}
            onChange={handleOnChange}
        />
    );

    if (canBrowse && !readOnly) {
        const inline = props.inline || (options != null && options.inline);
        const browseTitle = props.browseTitle || (options != null && options.browseTitle) || 'Browser Server';
        const browseInstanceId = props.browseInstanceId || (options != null && options.browseInstanceId);
        const onBrowse = props.onBrowse || options?.onBrowse;

        const handleOnBrowseClick = () => {
            if (typeof onBrowse === 'function') {
                onBrowse((value) => {
                    setValue(value);
                    handleOnChange(value);
                });

                return;
            }

            if (browseInstanceId != null) {
                const onURLSet = props.onURLSet || options?.onURLSet;

                createResourceBrowserDialog(props.glob, browseInstanceId, () => {
                    const obj = ResourceBrowser.getFirstSelectedResource(browseInstanceId);

                    if (obj != null) {
                        const url = obj.url;

                        if (onURLSet != null) {
                            onURLSet(url);
                        }

                        setValue(url);
                        handleOnChange(url);
                    }
                });
            }
        };

        const cellStyle: React.CSSProperties = {
            padding: '0px',
            height: '1.5rem'
        };

        let browseCellStyle = cellStyle;
        let tableClass = 'table-borderless';

        if (!inline) {
            tableClass += ' w-100';
            browseCellStyle = { ...browseCellStyle };
            browseCellStyle.width = '2rem';
        }

        content = (
            <table className={tableClass}>
                <tbody>
                    <tr>
                        <td className="uri-cell" style={cellStyle}>
                            {content}
                        </td>

                        <td className="browse-cell" style={browseCellStyle}>
                            <button
                                className="btn btn-default"
                                title={browseTitle}
                                style={{
                                    margin: '0px',
                                    padding: '0.3rem 0.4rem'
                                }}
                                onClick={handleOnBrowseClick}
                            >
                                <span className="glyphicon glyphicon-search"></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    return <div className="uri-field">{content}</div>;
}
